/**
 * Trunnion AI - Tools API Endpoints
 */

import apiClient from './client';
import type {
  ToolDefinition,
  ToolListResponse,
  CreateToolRequest,
  UpdateToolRequest,
} from '@/types';

const BASE = '/tools';

export const toolsApi = {
  list: async (params?: {
    page?: number;
    pageSize?: number;
    search?: string;
    category?: string;
    classification?: string;
    isActive?: boolean;
  }): Promise<ToolListResponse> => {
    const { data } = await apiClient.get(BASE, { params });
    return data;
  },

  getById: async (id: string): Promise<ToolDefinition> => {
    const { data } = await apiClient.get(`${BASE}/${id}`);
    return data;
  },

  create: async (tool: CreateToolRequest): Promise<ToolDefinition> => {
    const { data } = await apiClient.post(BASE, tool);
    return data;
  },

  update: async (id: string, tool: UpdateToolRequest): Promise<ToolDefinition> => {
    const { data } = await apiClient.put(`${BASE}/${id}`, tool);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${id}`);
  },

  test: async (
    id: string,
    parameters: Record<string, unknown>,
  ): Promise<{ success: boolean; result: unknown; error?: string }> => {
    const { data } = await apiClient.post(`${BASE}/${id}/test`, { parameters });
    return data;
  },
};
